import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import storeFactory from '../store/store';

const initialState = window.__INITIAL_STATE__;
const store = storeFactory(initialState);

export const renderReactComponentWithRedux = (WrappedComponent, root, props = null) =>
    render(
        <Provider store={store}>
            <WrappedComponent { ...props } />
        </Provider>,
        root
    );
